/* 布局 */
//前台
import Layout from "@views/layout";

const templatemanageactivityinvitaionRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "templatemanageactivityinvitaion",
            name: "TEMPLATEMANAGEACTIVITYINVITAION",
            meta: {
                title: "邀请函模板",
                sort: 1,
            },
            component: () => import("@views/business/templatemanageactivityinvitaion/index.vue"),
            redirect: {
                name: "TEMPLATEMANAGEACTIVITYINVITAION_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TEMPLATEMANAGEACTIVITYINVITAION_LIST",
                    meta: {
                        title: "邀请函模板",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/templatemanageactivityinvitaion/list.vue"),
                },
                                {
                    path: "add",
                    name: "TEMPLATEMANAGEACTIVITYINVITAION_ADD",
                    meta: {
                        title: "新增模板管理-活动邀请函模板",
                        parentPath: '/business/templatemanageactivityinvitaion/list',
                        operate: true,
                    },
                    component: () => import("@views/business/templatemanageactivityinvitaion/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "TEMPLATEMANAGEACTIVITYINVITAION_EDIT",
                    meta: {
                        title: "编辑模板管理-活动邀请函模板",
                        parentPath: '/business/templatemanageactivityinvitaion/list',
                        operate: true,
                    },
                    component: () => import("@views/business/templatemanageactivityinvitaion/form.vue"),
                },
                                        ],
    },


        ],
};

export default templatemanageactivityinvitaionRouter;
